/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Task&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Task&lang=js"

import "./index.vue?vue&type=style&index=0&id=1aea3bad&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aea3bad"]])

export default __exports__